import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, catchError, map } from 'rxjs';
import { IssueTrackerUserDTO } from '../models/issue-tracker-user-dto';
import { environment } from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})

export class UserService {

  private pathAPI = environment.urlAPI;
  private controller = "IssueTrackerUser/";

  public userData = new BehaviorSubject<IssueTrackerUserDTO>(null);

  constructor(private http: HttpClient) { }

  public initializeUserData() {
    const that = this;
    this.getUserInfo().subscribe(resp => {
      that.setUserData(resp);
    });
  }

  public getUserInfo(): Observable<IssueTrackerUserDTO> {
    return this.http.get<IssueTrackerUserDTO>(this.pathAPI + this.controller + 'GetLoggedUserInfo');
  }

  public updateLastLoginDate(): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + 'UpdateLastLoginDate');
  }

  setUserData(user: IssueTrackerUserDTO) {
    this.userData.next(user);
  }

  getUserData(): Observable<IssueTrackerUserDTO> {
    if (this.userData.value != null) {
      return this.userData.asObservable();
    }
    else {
      return this.getUserInfo().pipe(map((userData) => {
        this.userData.next(userData);
        return userData;
      }),
        catchError((err) => {
          return this.userData.asObservable();
        }));
    }
  }
}
